<template>

	<v-dialog
		v-if="$vuetify.display.mobile"
		v-model="showDepositDetails"
		:fullscreen="$vuetify.display.mobile"
		class="deposit-details-modal"
		>
		<v-card class="px-4 d-flex flex-column">
			<div class="d-flex flex-row justify-space-between align-start">
				<v-btn variant="plain" color="primary" size="x-small" class="modal-close px-0 my-6" @click="showDepositDetails = false">
					<img :src="back_icon" width="6" class="mr-4"/>
					{{ $t('deposits.list.details_back_btn') }}
				</v-btn>
			</div>
			<div class="modal-header py-4 mb-4">{{ $t('deposits.list.details_header') }} {{deposit.deposit_number}}</div>
			
			<div v-if="showDepositDetails" :class="['details mx-0 w-100', !$vuetify.display.mobile ? 'desktop' : '']">
				<div v-if="!detailsLoading">
					<div class="details-header d-flex flex-column justify-space-between">
						<div class="flex-grow-1">
							<span class="label">{{$t('deposits.list.paid_for_date_label')}}</span><br/>
							<span class="data">{{ getPaymentDate() }}</span>
						</div>
						<div class="flex-grow-1">
							<span class="label" v-if="details.medical_process">{{$t('deposits.list.process_number_label')}}</span><br/>
							<span class="data" v-if="details.medical_process">{{ details.medical_process }}</span>
						</div>
						<div class="flex-grow-1">
							<span class="label" v-if="details.ivf_procedure">{{$t('deposits.list.procedure_number_label')}}</span><br/>
							<span class="data" v-if="details.ivf_procedure">{{ details.ivf_procedure}}</span>
						</div>
					</div>
					<div class="materials-header py-2 mt-8 text-uppercase">
						{{$t('deposits.list.details_label')}}
					</div>
					<div v-for="(material, index) in details.materials" :key="index" class="element">
						<div class="details-header-mobile d-flex flex-column justify-space-between my-4">
							<div class="flex-grow-1" v-if="material.number">
								<span class="label">{{$t('deposits.list.material_number_label')}}</span><br/>
								<span class="number">{{ material.number }}</span>
							</div>
							<div class="flex-grow-1" v-if="material.fitness_for_insemination">
								<span class="label">{{$t('deposits.list.fitness_label')}}</span><br/>
								<span class="data">{{ material.fitness_for_insemination }}</span>
							</div>
							<div class="flex-grow-1" v-if="material.size">
								<span class="label">{{$t('deposits.list.count_label')}}</span><br/>
								<span class="data">{{ material.size }}</span>
							</div>
							<div class="flex-grow-1" v-if="material.morphology">
								<span class="label">{{$t('deposits.list.morphology_label')}}</span><br/>
								<span class="data">{{ material.morphology }}</span>
							</div>
							<div class="flex-grow-1" v-if="material.pgd_biopsy !== null">
								<span class="label">{{$t('deposits.list.biopsy_label')}}</span><br/>
								<span class="data">{{ material.pgd_biopsy ? $t('YES') : $t('NO') }}</span>
							</div>
							<div class="flex-grow-1" v-if="material.pgd_biopsy !== null">
								<span class="label">{{$t('deposits.list.pgd_result_label')}}</span><br/>
								<span class="data">{{ getPgd(material.pgd_result) }}</span>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="w-100 d-flex flex-row justify-center mt-10">
					<v-progress-circular
						indeterminate
						color="primary"
						:size="50"
						:width="5"
					></v-progress-circular>
				</div>
			</div>
			
		</v-card>
	</v-dialog>
	<div 
		v-if="deposit?.mz_grant"
		:class="['mz-package-label px-1 py-1 mt-2 ml-4 d-flex', {'mt-6': $vuetify.display.mobile}]">
		<img :src="paidIcon" class="mr-1"/> {{ $t('mz.one_refund_package_label') }}
	</div>
	<div class="data-row d-flex flex-wrap flex-md-row flex-column pa-4 py-md-4 text-left invicta"
		:class="{'expand': showDepositDetails && !$vuetify.display.mobile}">
		

		<div class="deposits-number-wrapper-mobile ml-0 mb-3 mt-2">
			<div v-if="$vuetify.display.mobile" class="label mb-1">
				{{$t('deposits.list.deposit_number_label').replace('\n','')}}
			</div>
			<span class="number">{{deposit.deposit_number}}</span><br>
			<span class="type">{{getType(deposit.material_type)}}</span>
		</div>

		<div class="deposits-number-wrapper ml-0 mb-3 mt-2">
			<div v-if="$vuetify.display.mobile" class="label mb-1">
				{{$t('deposits.list.localization_label')}}
			</div>
			{{deposit.localization_city}}
		</div>

		<div class="deposits-number-wrapper ml-0 mb-3 mt-2">
			<div v-if="$vuetify.display.mobile" class="label mb-1">
				{{$t('deposits.list.date_label')}}
			</div>
			{{deposit.creation_date}}
		</div>

		<div class="deposits-number-wrapper ml-0 mb-3 mt-2">
			<div v-if="$vuetify.display.mobile" class="label mb-1">
				{{$t('deposits.list.deposit_type_label')}}
			</div>
			{{deposit.from_reservation ? $t('reservation.reservation') : $t('reservation.own')}}
		</div>

		<div class="deposits-number-wrapper ml-0 mb-md-0 mb-6 mt-2">
			<div v-if="$vuetify.display.mobile" class="label mb-1">
				{{$t('deposits.list.payment_status_label')}}
			</div>
			<span :class="['payment-status', deposit.payment_status]">{{getStatus(deposit.payment_status)}}</span>
		</div>

		<v-spacer v-if="!$vuetify.display.mobile"></v-spacer>

		<div v-if="!$vuetify.display.mobile" class="text-right mt-2">
			<v-btn flat icon color="transparent" density="compact" @click="toggleDepositDetails()">
				<img :src="showDepositDetails ? chevron_up_icon : chevron_down_icon" />
			</v-btn>
		</div>

		<div v-if="showDepositDetails && !$vuetify.display.mobile" :class="['break line']"></div>

		<div v-if="showDepositDetails" :class="['details mx-0 w-100', !$vuetify.display.mobile ? 'desktop' : '']">
			<div v-if="!detailsLoading">
				<div class="details-header d-flex justify-space-between pt-6 px-4">
					<div class="flex-grow-1">
						<span class="label">{{$t('deposits.list.paid_for_date_label')}}</span><br/>
						<span class="data">{{ getPaymentDate() }}</span>
					</div>
					<div class="flex-grow-1" v-if="details.medical_process">
						<span class="label">{{$t('deposits.list.process_number_label')}}</span><br/>
						<span class="data">{{ details.medical_process }}</span>
					</div>
					<div class="flex-grow-1" v-if="details.ivf_procedure">
						<span class="label">{{$t('deposits.list.procedure_number_label')}}</span><br/>
						<span class="data">{{ details.ivf_procedure}}</span>
					</div>
					<div class="flex-grow-1" v-if="!$vuetify.display.mobile && deposit.donor_phenotype">
						<div class="donor-phenotype w-100">
							<div class="d-flex flex-row align-start justify-end mr-2">
								<div class="text-left w-auto panel">
									<compare-to-donor-component 
										:donor_phenotype="{phenotype: deposit.donor_phenotype}"
										:donor_nickname="deposit.donor_nickname ?? ''"
										:donor_product_key="deposit.donor_product_key"
										:donor_material_type="deposit.material_type"
										:user_id="oidcUser.user_id"
										:oidc_user="oidcUser"
										:key="deposit.deposit_number"
										:type="'deposit'"
										:action="null">
									</compare-to-donor-component>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="materials-header pa-4 mt-6 text-uppercase">
					{{$t('deposits.list.details_label')}}
				</div>
				<div v-for="(material, index) in details.materials" :key="index" class="element">
					<div class="details-header d-flex justify-space-between px-4">
						<div class="flex-grow-1 py-6" v-if="material.number">
							<span class="label">{{$t('deposits.list.material_number_label')}}</span><br/>
							<span class="number">{{ material.number }}</span>
						</div>
						<div class="flex-grow-1 py-6" v-if="material.fitness_for_insemination">
							<span class="label">{{$t('deposits.list.fitness_label')}}</span><br/>
							<span class="data">{{ material.fitness_for_insemination }}</span>
						</div>
						<div class="flex-grow-1 py-6" v-if="material.size">
							<span class="label">{{$t('deposits.list.count_label')}}</span><br/>
							<span class="data">{{ material.size }}</span>
						</div>
						<div class="flex-grow-1 py-6" v-if="material.morphology">
							<span class="label">{{$t('deposits.list.morphology_label')}}</span><br/>
							<span class="data">{{ material.morphology }}</span>
						</div>
						<div class="flex-grow-1 py-6" v-if="material.pgd_biopsy !== null">
							<span class="label">{{$t('deposits.list.biopsy_label')}}</span><br/>
							<span class="data">{{ material.pgd_biopsy ? $t('YES') : $t('NO') }}</span>
						</div>
						<div class="flex-grow-1 py-6" v-if="material.pgd_biopsy !== null">
							<span class="label">{{$t('deposits.list.pgd_result_label')}}</span><br/>
							<span class="data">{{ material.pgd_result ? material.pgd_result : '-' }}</span>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="w-100 d-flex flex-row justify-center mt-10">
				<v-progress-circular
					indeterminate
					color="primary"
					:size="50"
					:width="5"
				></v-progress-circular>
			</div>
		</div>

		<div class="donor-phenotype mt-4 w-100" v-if="$vuetify.display.mobile && deposit.donor_phenotype">
			<div class="d-flex flex-column align-center">
				<div class="text-left mb-4 w-auto panel">
					<compare-to-donor-component 
						:donor_phenotype="{phenotype: deposit.donor_phenotype}"
						:donor_nickname="deposit.donor_nickname ?? ''"
						:donor_product_key="deposit.donor_product_key"
						:donor_material_type="deposit.material_type"
						:user_id="oidcUser.user_id"
						:oidc_user="oidcUser"
						:key="deposit.deposit_number"
						:type="'deposit'"
						:action="null">
					</compare-to-donor-component>
				</div>
			</div>
		</div>

		<v-btn v-if="$vuetify.display.mobile" rounded variant="outlined" height="48" class="mb-4" @click="toggleDepositDetails()">
			{{ $t('deposits.list.details_btn') }}
		</v-btn>
	</div>
</template>


<script>
import axios from "axios";
import { computed } from "vue";
import { useStore } from 'vuex';
import CompareToDonorComponent from './CompareToDonorComponent.vue';

export default {
	name: "deposit-component",
	data: () => {
		return {
			showDepositDetails: false,
			detailsLoading: false,
			details: null,
		}
	},
	props: {
		deposit: {
			type: Object
		}
	},
	components: {
		CompareToDonorComponent
	},
	setup() {
		const store = useStore()
		const chevron_down_icon = computed({
			get: () => { return require('../assets/icons/chevron-down-primary.svg'); }
		})
		const chevron_up_icon = computed({
			get: () => { return require('../assets/icons/chevron-up-primary.svg'); }
		})
		const back_icon = computed({
			get: () => { return require('../assets/icons/chevron-left.svg'); }
		})
		const paidIcon = computed({
			get: () => { return require('@/assets/icons/paid.svg');}
		})
		return {
			chevron_down_icon,
			chevron_up_icon,
			back_icon,
			paidIcon,
			oidcUser: computed(() => store.getters['oidcStore/oidcUser'])
		}
	},
	methods: {
		toggleDepositDetails() {
			this.showDepositDetails = this.showDepositDetails ? false : true
			if(this.showDepositDetails) {
				this.detailsLoading = true;
				axios.get(`/api/person/deposits/${this.deposit.deposit_id}`)
				.then(response => {
					this.details = response.data;
				})
				.catch(error => {
					console.error(error);
				})
				.finally(() => {
					this.detailsLoading = false;
				})
			}
		},
		getStatus(status) {
			return this.$t(`deposits.list.payment_option.${status}`);
		},
		getType(type) {
			return this.$t(`deposits.list.material_type.${type}`);
		},
		getPgd(pgd){
			if(pgd) {
				return this.$t(`deposits.list.pgd_option.${pgd}`);
			} else {
				return '-'
			}
		},
		getPaymentDate() {
			if(this.deposit.mz_grant) {
				return this.deposit.payment_paid_to;
			} else {
				return this.details.payment_date ? this.details.payment_date : '-'
			}
		}
	}
}
</script>

<style lang="scss" scoped>

	.v-btn--variant-plain {
		opacity: 1 !important;
	}
	.v-btn--icon {
		&:hover {
			border: none !important;
			background: none !important;
		}
		&:focus {
			outline: none !important;
			border: none !important;
		}
	}

	.materials-header {
		@include nsb-font-header-bold;
		color: $ds-primary;
		font-size: 14px;
		line-height: 17.5px;
	}

	.details-header {
		gap: 32px;
		.label {
			color: $ds-primary-1;
			font-size: 12px;
			line-height: 18px;
		}
		.data {
			color: $ds-primary;
			font-size: 14px;
			line-height: 23px;
		}
		.number {
			@include nsb-gentium-bold;
			color: $ds-primary;
			font-size: 23px;
			line-height: 26px;
		}
	}
	.details-header-mobile {
		gap: 24px;
		.label {
			color: $ds-primary-1;
			font-size: 12px;
			line-height: 18px;
		}
		.data {
			color: $ds-primary;
			font-size: 14px;
			line-height: 23px;
		}
		.number {
			@include nsb-gentium-bold;
			color: $ds-primary;
			font-size: 23px;
			line-height: 26px;
		}
	}
	.data-row {
		position: relative;
		background: $ds-white;
		border-bottom: 1px solid $ds-primary-300;
		gap: 12px 32px;
		&.expand {
			background: $ds-primary-300 !important;
		}

		.label {
			@include ds-font-label-medium;
		}

		.deposits-number-wrapper, .material-type-wrapper, .deposits-number-wrapper-mobile {
			width: 114px;
			.number {
				@include nsb-gentium-bold;
				color: $ds-primary;
				font-size: 23px;
				line-height: 26px;
			}
			.type {
				color: $ds-primary;
				font-size: 12px;
				line-height: 18px;
			}
		}
		.deposits-number-wrapper-mobile {
			width: unset;
		}

		.break {
			flex-basis: 95%;
			height: 1px;
			&.line {
				border-bottom: 1px solid $ds-primary-300;
			}
		}

		.details {
			background: white;
			&.desktop {
				min-height: 130px;
			}
		}

		.deposite-type {
			@include nsb-font-container;
			color: $ds-primary;
			border-radius: 12px;
			font-size: 12px;
			line-height: 18px;
			display: inline-block;
			background: $ds-primary-6;
			padding: 3px 12px;

			&.reservation {
				background: $ds-primary-7;
			}
		}
	}

	.deposit-details-modal {

		.modal-header {
			@include nsb-font-main-header;
			font-size: 28px;
		}

		.modal-body {
			@include nsb-font-container;
			font-size: 14px;
		}
	}

	.element {
		border-top: 1px solid $ds-primary-300;
	}

	.payment-status {
		background: gray;
		padding: 3px 12px;
		border-radius: 12px;
		color: $ds-primary;
		font-size: 12px;
		line-height: 18px;
		&.PAID {
			background: $ds-success-3;
		}
		&.UNPAID {
			background: $ds-error-3;
		}
		&.NONPAYABLE {
			background: $ds-primary-300;
		}
		&.NO_DATA {
			background: $ds-primary-300;
		}
		&.MZ_GRANT {
			background: $ds-success-3;
		}
	}
	.mz-package-label {
		@include nsb-font-container;
		line-height: normal;
		border-radius: 100px;
		background: #F0FFF3;
		color: #0DA531;
		width: max-content;
		&.f-right {
			float: right;
		}
	}
	.f-right {
		float: right;
	}

	.donor-phenotype {
		.panel {
			position: relative;
			border-radius: 12px;
			border: 1px solid transparent !important;
			cursor: pointer;
		}
		.panel:hover {
			border: 1px solid var(--nsb-color-1, #0E346F) !important;
		}
	}
</style>